import {
    BotReportingEventObject,
    JoinObject,
    LeaveObject,
    TypingObject,
    SessionTimeoutMessage,
    PingMessage
} from "../../types/chat";
import {AgentEvent, MessageSendState} from "../../types/enums";
import AgentChatConnector from "./connector/agentChatConnector";
import AbstractWebsocketChat from "../abstractWebsocketChat";

export class ChatEventHandler {

    constructor( private chat: AbstractWebsocketChat ) {}

    public async handleOnEvent(data: any): Promise<void>
    {
        if(!this.chat.isAgentChat()) {
            return;
        }

        if(data.code === undefined || data.code !== 200) {
            this.chat.handleWebsocketError('onEvent code invalid', {
                messageType: 'AgentEvent',
                reason: 'code invalid'
            });
            return;
        }

        switch (data.class) {
            case AgentEvent.CONNECTED:
                // wird im connector gehandhabt
                break;
            case AgentEvent.MESSAGE_RECEIVED:
                if(data.messageId) {
                    this.chat.changeMessageStatus(data.messageId, MessageSendState.RECEIVED);
                }
                break;
            case AgentEvent.TYPING:
                if(data.duration !== undefined) {
                    this.chat.setAgentIsTyping(data.duration);
                }
                break;
            case AgentEvent.LEAVE:
                let leftByBot = data.originatingEntity !== "Human" && !this.chat.hasSomeMessages();
                await this.chat.setAgentLeft(leftByBot);
                break;
            case AgentEvent.SESSION_ACTIVE:
                // nur neu starten, wenn sessionTimeout nicht erreicht, sonst beenden
                let chatConnector = this.chat.getChatConnector();
                if (chatConnector instanceof AgentChatConnector) {
                    const lastActivity = new Date(data.lastActivity);
                    const now = new Date();
                    const diffInSeconds = Math.floor((now.getTime() - lastActivity.getTime()) / 1000);

                    await chatConnector.updateDisconnectTimer(diffInSeconds);
                }
                break;
            case AgentEvent.CONNECTION_LOST:
                let connector = this.chat.getChatConnector();
                if (connector instanceof AgentChatConnector) {
                    connector.intentionalDisconnect = true;
                    await connector.closeWebsocketConnection();
                    await connector.initConnection();
                    connector.intentionalDisconnect = false;
                }
                break;
        }
    }

    public handleSendJoinEvent = (chatWebSocket: WebSocket, joinObject: JoinObject, onError: () => void): void =>
    {
        chatWebSocket.send(JSON.stringify(joinObject));
    }

    public handleSendTypingEvent = (chatWebSocket: WebSocket, typingObject: TypingObject, onError: () => void): void =>
    {
        chatWebSocket.send(JSON.stringify(typingObject));
    }

    public handleSendLeaveEvent(chatWebSocket: WebSocket|null, leaveObject: LeaveObject): void
    {
        chatWebSocket?.send(JSON.stringify(leaveObject));
    }

    public handleSendEventError= (): void =>
    {
        this.chat.handleWebsocketError('send Event Error', {
            messageType: 'AgentEvent',
            reason: 'Fehler beim Senden des Events',
        });
    }

    public handleSendReportingEvent = (chatWebSocket: WebSocket, reportingEvent: BotReportingEventObject): void =>
    {
        chatWebSocket.send(JSON.stringify(reportingEvent));
    }
    public handleSendConnectionTimeoutEvent = (chatWebSocket: WebSocket, sessionTimeoutMessage: SessionTimeoutMessage, onError: () => void ): void =>
    {
        chatWebSocket.send(JSON.stringify(sessionTimeoutMessage));
    }
    public handleSendPing = (chatWebSocket: WebSocket, pingMessage: PingMessage, onError: () => void ): void =>
    {
        chatWebSocket.send(JSON.stringify(pingMessage));
    }
}